import * as React from 'react';
import { useIntl } from 'react-intl';
import { ConstCenterRecord } from './types';
import DeleteAction from '../CmdTable/TableActions/DeleteAction';
import { TABLE_COST_CENTERS } from '../../Services/TableService';

interface RemoveAction {
  data: ConstCenterRecord;
  handleRemove: (data: ConstCenterRecord) => void;
}

export default function RemoveAction(props: RemoveAction) {
  const { formatMessage: f } = useIntl();
  // const [isToastrOpened, setIsToastrOpened] = React.useState(false);

  // const getRemoveConfirmDialogText = () => {
  //   const messages: string[] = [];
  //   const date = new Date();
  //   let deleteMessage = '';
  //   if (date <= new Date(props.data.validUntil)) {
  //     const validUntil = dayjs(props.data.validUntil).format('DD.MM.YYYY');
  //     messages.push(
  //       f({ id: 'table.confirm.dialog.remove.message.fuel.card.validUntil' }, { date: validUntil })
  //     );
  //   }
  //   if (props.data.assignedTo && props.data.assignedTo !== '[N/A]') {
  //     messages.push(
  //       f(
  //         { id: 'table.confirm.dialog.remove.message.fuel.card.vehicleId' },
  //         { name: props.data.assignedTo }
  //       )
  //     );
  //   }
  //   messages.push(
  //     `${date <= new Date(props.data.validUntil) || props.data.assignedTo ? '<br />' : ''}${f({
  //       id: 'table.confirm.dialog.remove.message.fuel.card',
  //     })}`
  //   );

  //   deleteMessage = messages.join('<br />');
  //   return deleteMessage;
  // };

  const handleOnClick = () => {
    props.handleRemove(props.data);
  };

  return (
    <>
      <DeleteAction
        id={props.data.id}
        tableName={TABLE_COST_CENTERS}
        customerId={props.data.customer.id}
        onClickCallback={handleOnClick}
        showConfirmDialog={true}
        confirmDialogMessage={`${f({ id: 'constCenters.confirm.remove.message' }, { name: props.data.name })}`}
      />
      {/* {isToastrOpened && (
        <ConfirmToaster
          id="toast"
          title={f({
            id: 'table.confirm.dialog.remove.title',
          })}
          // message={getRemoveConfirmDialogText()}
          message=""
          type="warning"
          duration={null}
          onClose={handleConfirmCancel}
          buttons={[
            {
              title: f({
                id: 'form.cancel',
              }),
              style: 'link',
              type: 'cancel',
              onClickCallback: handleConfirmCancel,
            },
            {
              title: f({
                id: 'table.deleteBtn',
              }),
              style: 'solid',
              type: 'confirm',
              onClickCallback: handleOnClick,
            },
          ]}
        />
      )} */}
    </>
  );
}
